import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import LanguageSwitcher from './LanguageSwitcher';
import ThemeSwitcher from './ThemeSwitcher';
import ColorThemeSwitcher from './ColorThemeSwitcher';
import Tooltip from './Tooltip';
import './Navigation.css';

const Navigation: React.FC = () => {
  const location = useLocation();
  const { t } = useLanguage();
  const [currentTime, setCurrentTime] = useState(new Date().toLocaleTimeString());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date().toLocaleTimeString());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav className="navbar">
      <div className="nav-container">
        <Tooltip title="Sentinel" description={t('nav.sentinelDescription') || ''}>
          <Link to="/" className="nav-logo">
            🛡️ Sentinel
          </Link>
        </Tooltip>
        <ul className="nav-menu">
          <li className="nav-item">
            <Link
              to="/"
              className={`nav-link ${isActive('/') ? 'active' : ''}`}
            >
              {t('nav.dashboard')}
            </Link>
          </li>
          <li className="nav-item">
            <Link
              to="/events"
              className={`nav-link ${isActive('/events') ? 'active' : ''}`}
            >
              {t('nav.alerts')}
            </Link>
          </li>
          <li className="nav-item">
            <Link
              to="/policies"
              className={`nav-link ${isActive('/policies') ? 'active' : ''}`}
            >
              {t('nav.policies')}
            </Link>
          </li>
        </ul>
        <div className="nav-right">
          <div className="nav-timestamp">{currentTime}</div>
          <ColorThemeSwitcher />
          <ThemeSwitcher />
          <LanguageSwitcher />
        </div>
      </div>
    </nav>
  );
};

export default Navigation;

